import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import AccessoryInfoItem from '../../containers/accessory-info-item';
import Wysiwyg from '../../containers/wysiwyg';
import Promo from '../../containers/promo';
import Video from '../../blocks/video';
import Presentation from '../../blocks/presentation';
import Picker from '../../blocks/picker';
import OneColumnLayout from '../../blocks/one-column-layout';
import TwoColumnLayout from '../../blocks/two-column-layout';
import ThreeColumnLayout from '../../blocks/three-column-layout';
import FourColumnLayout from '../../blocks/four-column-layout';

const AccessoryInfoItemBlock = props => <AccessoryInfoItem {...props} />;
AccessoryInfoItemBlock.displayName = 'AccessoryInfoItem';

export default withDynamicComponents({
  componentWhitelist: [
    Wysiwyg,
    Promo,
    Video,
    Presentation,
    Picker,
    OneColumnLayout,
    TwoColumnLayout,
    ThreeColumnLayout,
    FourColumnLayout
  ],
  mapInputToOutput: [
    
  ],
})(AccessoryInfoItemBlock);



// WEBPACK FOOTER //
// ./src/blocks/accessory-info-item/index.jsx